'use client';

import { useCategoriesData } from '@/src/redux/categoriesDataContext';

export function useGetCategoryById() {
  const categoriesData = useCategoriesData();

  const searchChildren = (id: number, children: any) => {
    let category = null as null | any;
    if (!children || !children.length) {
      return null;
    }
    children.forEach((child: any) => {
      if (category) {
        return;
      }
      if (id === child.id) {
        category = child;
      } else if (child.children) {
        category = searchChildren(id, child.children);
      }
    });
    return category;
  };

  return (id: number) => {
    let category = null as null | any;
    if (!categoriesData || !categoriesData.length) {
      return null;
    }
    categoriesData?.forEach((cat) => {
      if (category) {
        return;
      }
      if (id === cat.id) {
        category = cat;
      } else if (cat.children) {
        category = searchChildren(id, cat.children);
      }
    });
    return category;
  };
}
